export const USER_PROFILE_UPDATED_EVENT = 'user-profile:updated';

export type UserProfileUpdatedDetail = {
  email?: string | null;
  displayName?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  role?: string | null;
  title?: string | null;
  agentTitle?: string | null;
  photoURL?: string | null;
};

export function dispatchUserProfileUpdated(detail: UserProfileUpdatedDetail) {
  try {
    window.dispatchEvent(
      new CustomEvent<UserProfileUpdatedDetail>(USER_PROFILE_UPDATED_EVENT, {
        detail,
      }),
    );
  } catch {}
}
